import { gql } from '@apollo/client';

import { TestResultsQuestionFragment } from './test-results-question';

export const TestResultsFragment = gql`
    fragment TestResults on OLTestResults {
        id
        userId
        subjectId
        courseId
        questions {
            ...TestResultsQuestion
        }
    }
    ${TestResultsQuestionFragment}
`;
